import axios from '_u/axios'

//提醒设置查看
export const notifyDetail = () => {
    return axios.post('api/setting/remind/detail')
}

//提醒设置查看
export const notifyAdd = (body) => {
    return axios.post('api/setting/remind/add', body)
}

//提醒设置查看
export const notifyUpdate = (body) => {
    return axios.post('api/setting/remind/update', body)
}

// 收款设置列表
export const collectList = () => {
    return axios.post('api/setting/collect/list')
}

// 收款设置详情
export const collectView = (houseId) => {
    return axios.post('api/setting/collect/view', { houseId })
}

// 设置收款方式(单个/批量)
export const collectSetting = (body) => {
    return axios.post('api/setting/collect/setting', body)
}

// 付款设置
export const setPayType = (body) => {
    return axios.post('api/assets/floor/setPayType', body)
}

// 查询付款设置
export const queryPayType = () => {
    return axios.post('api/assets/floor/queryPayType')
}

// 根据房源id查询付款方式,手续费等
export const smartQueryPayType = (houseId) => {
    return axios.post('api/setting/smartmeter/queryPayType', { houseId })
}

// 获取当前商户线下支付开关
export const getOfflinePaySwitch = (body) => {
    return axios.post('/api/setting/collect/getOfflinePaySwitch', body)
}
